import { FormControl } from 'parkdepot-shared/components/FormControl'
import { Value } from 'baseui/select'
import { BaseSelect } from 'parkdepot-shared/components/Select'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface TariffSelectProps {
    onChange: (value: Value) => void
    value: Value | null
    options: { id: string; label: string }[]
}

const TariffSelect = ({ onChange, value, options }: TariffSelectProps) => {
    const { t } = useTranslation()

    return (
        <FormControl label={t('carpay.paymentInput.tariff')} data-testid="user-input-form-tariff-select">
            <BaseSelect
                overrides={{
                    Input: { props: { 'data-testid': 'user-input-tariff-select', readOnly: true } },
                    Root: { props: { 'data-testid': 'user-input-tariff-select-root' } }
                }}
                clearable={false}
                value={value ?? []}
                searchable={false}
                onChange={(option) => onChange(option.value)}
                placeholder={t('carpay.paymentInput.tariff')}
                options={options}
                labelKey="label"
                valueKey="id"
            />
        </FormControl>
    )
}

export default TariffSelect
